const songList = [
  {
    product: "MAJOR/ALPHA/CELLO/X3/PIANO XL HDD",
    years: [
      {
        year: 2026,
        months: [
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/pr2u1ikmvayqdye/HDD_2026_November_Additional_Song_List.pdf/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/druxgc6297ckjgx/HDD_2026_October_Additional_Song_List.pdf/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/s0nqgwlzcy988x5/HDD_2026_September_Additional_Song_List.pdf/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/q5aerl40ba11edu/HDD_2026_August_Additional_Song_List.pdf/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/5gk6mjdpponm17x/HDD_2026_July_Additional_Song_List.pdf/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/dyvv3n2ydksak48/HDD_2026_June_Additional_Song_List.pdf/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/wlhgi6b7op1v33f/HDD_2026_May_Additional_Song_List.pdf/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/mqzf0xlg3eeteuv/HDD_2026_April_Additional_Song_List.pdf/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/dcfcla3wl5g12mx/HDD_2026_March_Additional_Song_List.pdf/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/rlw85lnxt1vi56b/HDD_2026_February_Additional_Song_List.pdf/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/8526ztg6tmk833t/HDD_2026_January_Additional_Song_List.pdf/file",
          },
        ],
      },
      {
        year: 2025,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/c1hv3eq7qugq9m3/HDD_2025_December_Additional_Song_List.pdf/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/r67iolzzrffl1m6/HDD_2025_November_Additional_Song_List.pdf/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/99nl9w6a2tetrup/HDD_2025_October_Additional_Song_List.pdf/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/eug4tql5jj5ixb7/HDD_2025_September_Additional_Song_List.pdf/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/bna9mgf2zlz9w79/HDD_2025_August_Additional_Song_List.pdf/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/xadbew2tzeh23no/HDD_2025_July_Additional_Song_List.pdf/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/c2k9rvpnynvpmdt/HDD_2025_June_Additional_Song_List.pdf/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/rz8hsw6ri1tpf16/HDD_2025_May_Additional_Song_List.pdf/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/ii0czfjbnpvpqb2/HDD_2025_April_Additional_Song_List.pdf/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/7ppvhtph1bt198f/2025_March_Additional_Song_List.pdf/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/r8lzzooe0dbhtjh/HDD_2025_February_Additional_Song_List.pdf/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/dxpmlxp4qj5h1mk/2025_January_Additional_Song_List.pdf/file",
          },
        ],
      },
      {
        year: 2024,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/tu6occevcxhvpsf/HDD_2024_December_Additional_Song_List.pdf/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/czsoyg5iovxleez/HDD_2024_November_Additional_Song_List.pdf/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/8exadhgxwzjttl9/HDD_2024_October_Additional_Song_List.pdf/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/letoafh5sx8a4x8/HDD_2024_September_Additional_Song_List.pdf/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/mi160g1iin3bxui/HDD_2024_August_Additional_Song_List.pdf/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/56ygcbrqkjmt4i9/HDD_2024_July_Additional_Song_List.pdf/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/8jideqo6ga2jd7r/HDD_2024_June_Additional_Song_List.pdf/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/6bqctt8niyt6q7m/HDD_2024_May_Additional_Song_List.pdf/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/zyzih7t38genk67/HDD_2024_April_Additional_Song_List.pdf/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file_premium/17qb643ssunpbzq/HDD_2024_March_Additional_Song_List.pdf/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file_premium/29cgp0mfdz9ikm0/HDD_2024_February_Additional_Song_List.pdf/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file_premium/9oaye2rvylkn3dx/HDD_2024_January_Additional_Song_List.pdf/file",
          },
        ],
      },
      {
        year: 2023,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file_premium/nbi0t0k4iferdog/HDD_2023_December_Additional_Song_List.pdf/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file_premium/7wv0jubgghnigj5/HDD_2023_November_Additional_Song_List.pdf/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file_premium/5qjhfbnuhc0kiwh/HDD_2023_October_Additional_Song_List.pdf/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file_premium/qleuoaff6v6nm95/HDD_2023_September_Additional_Song_List.pdf/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file_premium/juiwg1hpr9lckrc/HDD_2023_August_Additional_Song_List.pdf/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file_premium/v10509a5d2bcm1i/HDD_2023_July_Additional_Song_List.pdf/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file_premium/59eyehql9rrwtts/HDD_2023_June_Additional_Song_List.pdf/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file_premium/75wa5x7yil9i8f0/HDD_2023_May_Additional_Song_List.pdf/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file_premium/w5976y0ktghpdkk/HDD_2023_April_Additional_Song_List.pdf/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/b6vape6vd65nzv1/HDD_2023_March_Additional_Song_List.pdf/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/6x3enidg56wv0z6/HDD_2023_February_Additional_Song_List.pdf/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/clgya38kaini6xn/HDD_2023_January_Additional_Song_List.pdf/file",
          },
        ],
      },
      {
        year: 2022,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/xuvj7srlf4txmey/HDD_2022_December_Additional_Song_List.pdf/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/eire0qr3f8012px/HDD_2022_November_Additional_Song_List.pdf/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/nzdbf1jtznarte7/HDD_2022_October_Additional_Song_List.pdf/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/wme0t583fba09rw/HDD_2022_September_Additional_Song_List.pdf/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/84upktaolc3i2cp/HDD_2022_August_Additional_Song_List.pdf/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/u970i2xkd2yrgmz/HDD_2022_JUly_Additional_Song_List.pdf/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/pzyiptd107s2g07/HDD_2022_June_Additional_Song_List.pdf/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/sstzr42w2196c84/2022_May_Additional_Song_List.pdf/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/qs12b9h1ixoxq35/HDD_2022_April_Additional_Song_List.pdf/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/mozns6nb6n4gbjx/HDD_2022_March_Additional_Song_List.pdf/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/8ppuseo5oqw32j5/HDD_2022_February_Additional_Song_List.pdf/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/qs0pfvzysqmhyjp/HDD_2022_January_Additional_Song_List.pdf/file",
          },
        ],
      },
      {
        year: 2021,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/n6hanasgjmavjti/HDD_2021_December_Additional_Song_List.pdf/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/r479ma2epa8genp/HDD_2021_November_Additional_Song_List.pdf/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/0w111jnqegpft66/HDD_2021_October_Additional_Song_List.pdf/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/0vw9xdydsh99mad/HDD_2021_September_Additional_Song_List.pdf/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/hqaoglbbjvbexd2/HDD_2021_August_Additional_Song_List.pdf/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/11uap7xwtpi04wt/HDD_2021_July_Additional_Song_List.pdf/file",
          },
          {
            month: "June",
            link: "https://cdn.shopify.com/s/files/1/2581/7224/files/HDD_2021_June_Additional_Song_List.pdf?v=1622446880",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/e2iemz4fj8fk3uv/HDD_2021_May_Additional_Song_List.pdf/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/mo55osyhiaa9xsb/HDD_2021_April_Additional_Song_List.pdf/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/tt9vnqh1chnkx0p/HDD_2021_March_Additional_Song_List.pdf/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/qxijcaiyt330jcg/HDD_2021_February_Additional_Song_List.pdf/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/5pm8nap6wnphsxk/HDD_2021_January_Additional_Song_List.pdf/file",
          },
        ],
      },
      {
        year: 2020,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/jak2s16h0txazx0/2020_December_Additional_Song_List.pdf/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/98kk5gma8fts7g1/HDD_2020_November_Additional_Song_List.pdf/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/v7lsrk5jeui64hn/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/esn8fr9wlt2twwy/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/pyfbwaa8iavkmv2/HDD_2020_August_Additional_Song_List.pdf/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/kaog5il8olhv5w9/HDD_2020_July_Additional_Song_List.pdf/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/l1c4ptra5cpgvvd/HDD_2020_June_Additional_Song_List.pdf/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/g9xb72f6w9dcqtr/HDD_2020_May_Additional_Song_List.pdf/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/51xnwlzxt1miqia/HDD_2020_April_Additional_Song_List.pdf/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/hhqseij6k036oxo/HDD_2020_March_Additional_Song_List.pdf/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/7n52v783c9tdxq4/HDD_2020_February_Additional_Song_List.pdf/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/a0yyw4ckj9bk62f/HDD_2020_January_Additional_Song_List.pdf/file",
          },
        ],
      },
      {
        year: 2019,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/gcpl3qsj4i7wamk/HDD_2019_December_Additional_Song_List.pdf/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/yzn2nfpqr9lkzpb/HDD_2019_November_Additional_Song_List.pdf/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/lh1tlmjpiltdy9v/HDD_2019_October_Additional_Song_List.pdf/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/u7g89fqxyyt2i5g/HDD_2019_September_Additional_Song_List_%25282%2529.pdf/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/m4diek6cios42la/HDD_2019_August_Additional_Song_List.pdf/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/ia5oy76si3itsug/HDD_2019_July_Additional_Song_List.pdf/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/y63tgqniuqj9f0t/HDD_2019_June_Additional_Song_List.pdf/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/kyxrnj6c1txapz9/HDD_2019_May_Additional_Song_List_Alpha_Major_Cello_X3.pdf/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/4akdr4aqv4zh4mu/HDD_2019_April_Additional_Song_List.pdf/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/3wttpfmnnydhtn5/HDD_2019_March_Additional_Song_List.pdf/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/zbfkcxo0mmwhwjj/HDD_2019_February_Additional_Song_List.pdf/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/hs4jnkbj54hd0n7/HDD_2019_January_Additional_Song_List.pdf/file",
          },
        ],
      },
      {
        year: 2018,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/jw3jsawtwneclcr/HDD_2018_December_Additional_Song_List.pdf/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/u4vtudr744s1k8d/HDD_2018_November_Additional_Song_List.pdf/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/on6b7frzy2cv64i/HDD_2018_October_Additional_Song_List.pdf/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/9lyb1z2s66y7dcz/HDD_2018_September_Additional_Song_List.pdf/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/m2ma49cp1lza7si/HDD_2018_August_Additional_Song_List.pdf/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/lml85bf46a9tcyj/HDD_2018_July_Additional_Song_List.pdf/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/3ic6vo06zeefrwa/HDD_2018_June_Additional_Song_List.pdf/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/y06c22e8363aq2r/HDD_2018_May_Additional_Song_List.pdf/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/zf9oh0zanbavbau/HDD_2018_April_Additional_Song_List.pdf/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/5a91zc6ei60cpcd/HDD_2018_March_Additional_Song_List.pdf/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/jbeqkmxkzt59zj7/HDD_2018_February_Additional_Song_List.pdf/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/dhq6d6yhdepfvye/HDD_2018_January_Additional_Song_List.pdf/file",
          },
        ],
      },
      {
        year: 2017,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/rwwree448nllrg9/HDD_2017_December_Additional_Song_List.pdf/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/b0mkq1y785qkkkv/HDD_2017_November_Additional_Song_List.pdf/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/21v5c565u7wmw71/HDD_2017_October_Additional_Song_List.pdf/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/7na7iqhzyst4ftj/HDD_2017_September_Additional_Song_List.pdf/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/rbi980uzr8087wa/HDD_2017_Aug_Additional_Song_List.pdf/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/dwlv3x6852dzupm/HDD_2017_July_Additional_Song_List.pdf/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/9l94qi849ih90i3/HDD_2017_June_Additional_Song_List.pdf/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/bm3was9zmqy2ys8/HDD_2017_May_Additional_Song_List.pdf/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/g5utfdzcza329as/HDD_2017_April_Additional_Song_List.pdf/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/kdeqxbv5mo14pq8/HDD_2017_March_Additional_Song_List.pdf/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/3kpcwxch99vld6o/HDD_2017_February_Additional_Song_List.pdf/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/cy7x9esyp8dq586/HDD_2017_January_Additional_Song_List.pdf/file",
          },
        ],
      },
      {
        year: 2016,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/p1bv9zaj5ub7378/HDD_2016_December_Additional_Song_List.pdf/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/t6mw1gba6cnmmlw/HDD_2016_November_Additional_Song_List.pdf/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/ymm3a0kuulxwayn/HDD_2016_October_Additional_Song_List.pdf/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/c4k6l3r83xank0c/HDD_2016_September_Additional_Song_List.pdf/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/js8qasgimq949hl/HDD_2016_Aug_Additional_Song_List.pdf/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/e95vp888oamtldh/HDD_2016_July_Additional_Song_List.pdf/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/g8g9jtee9w7q2td/HDD_2016_June_Additional_Song_List.pdf/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/57jysac44il510m/HDD_2016_May_Additional_Song_List.pdf/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/8e42nee0wo91w3g/HDD_2016_April_Additional_Song_List.pdf/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/oyqz07d8y3wswcc/HDD_2016_March_Additional_Song_List.pdf/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/9lx5xbc6cc6u1jc/HDD_2016_February_Additional_Song_List_I.pdf/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/sqtimq7e6pmc68x/HDD_2016_January_Additional_Song_List.pdf/file",
          },
        ],
      },
      {
        year: 2015,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/lfm7185zhtrmb7d/HDD_2015_December_Additional_Song_List.pdf/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/4tofqzivfcz2fu6/HDD_2015_November_Additional_Song_List.pdf/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/h0uw3jeu88hniyu/HDD_2015_October_Additional_Song_List.pdf/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/h1g0me22t3x80x3/HDD_2015_September_Additional_Song_List.pdf/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/mpvd4377se2mcl1/HDD_2015_August_Additional_Song_List.pdf/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/ignkbir1ulrqp46/HDD_2015_July_Additional_Song_List.pdf/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/sfyzwyldkxgyvmb/HDD_2015_June_Additional_Song_List.pdf/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/86ki3gik9n9exbd/HDD_2015_May_Additional_Song_List.pdf/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/8zh4a0zs39vk62o/HDD_2015_April_Additional_Song_List.pdf/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/2ba6ojy5i6ppw54/HDD_2015_March_Additional_Song_List.pdf/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/0cvadg7ch6mnyxe/HDD_2015_February_Additional_Song_List.pdf/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/x5hzr3t9f3d4x1l/HDD_2015_January_Additional_Song_List.pdf/file",
          },
        ],
      },
    ],
  },
  {
    product: "FLUTE/PIANO V1.5/PIANO XL SD/PK10",
    volumes: [
      {
        volume: 108,
        link: "https://www.mediafire.com/file_premium/xljonnk7bnl5zo8/PianoFlute_Volume_108_Additional_List__yellow__-_p_260923_103524.pdf/file",
      },
      {
        volume: 107,
        link: "https://www.mediafire.com/file_premium/8d9z24h3bi0yy14/PianoFlute_Volume_107_Additional_List_%2528yellow%2529_-_pages_1-3.pdf/file",
      },
      {
        volume: 106,
        link: "https://www.mediafire.com/file_premium/rfy74u2wvmor2hx/PianoFlute_Volume_106_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: 105,
        link: "https://www.mediafire.com/file_premium/244s7q2b8enxlwt/PianoFlute_Volume_105_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: 104,
        link: "https://www.mediafire.com/file_premium/njcv591io7oinmz/PianoFlute_Volume_104_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: 103,
        link: "https://www.mediafire.com/file_premium/v0u92uq4x0sehcc/PianoFlute_Volume_103_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: 102,
        link: "https://www.mediafire.com/file_premium/irx7rn5yscl1taq/PianoFlute_Volume_102_Additional_List_-_page_1-2_only.pdf/file",
      },
      {
        volume: 101,
        link: "https://www.mediafire.com/file_premium/9d0e8gsbc556dzk/PianoFlute_Volume_101_Additional_List_-_page_1.pdf/file",
      },
      {
        volume: 100,
        link: "https://www.mediafire.com/file_premium/u6rv2frvk55urke/PianoFlute_Volume_100_Additional_List_-_pages_2.pdf/file",
      },
      {
        volume: 99,
        link: "https://www.mediafire.com/file_premium/y5trlmygoze019h/PianoFlute_Volume_99_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: 98,
        link: "https://www.mediafire.com/file_premium/90l0bwsat6ik4x0/PianoFlute_Volume_98_Additional_List_-_pages_1-4_only_%25282%2529.pdf/file",
      },
      {
        volume: 97,
        link: "https://www.mediafire.com/file_premium/b4shlvyurka0vyq/PianoFlute_Volume_97_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: 96,
        link: "https://www.mediafire.com/file_premium/kqos6ovogjf71hn/PianoFlute_Volume_96_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 95,
        link: "https://www.mediafire.com/file_premium/olqzacluu010qe1/PianoFlute_Volume_95_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 94,
        link: "https://www.mediafire.com/file_premium/1ujaga9j6johquo/T-X_Series_Volume_94_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 93,
        link: "https://www.mediafire.com/file/09kz827b2012rgp/T-X_Series_Volume_93_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 92,
        link: "https://www.mediafire.com/file/1vdczjv4d1jvk2a/T-X_Series_Volume_92_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 91,
        link: "https://www.mediafire.com/file/5g0ijysahpu1l9h/T-X,+Reyna,+Flute,+PK-10,+Piano+Series+Volume+91+Additional+List+-+pages+1-5+only.pdf/file",
      },
      {
        volume: 90,
        link: "https://www.mediafire.com/file/ecrsrwj4wq04pmu/PianoFlute+Volume+90+Additional+List+-+pages+1-3+only.pdf/file",
      },
      {
        volume: 89,
        link: "https://www.mediafire.com/file/9cxx0fk2eeirs66/Piano_Volume_89_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 88,
        link: "https://cdn.shopify.com/s/files/1/2581/7224/files/Piano_Volume_88_Additional_List_-_pages_1-4_only.pdf?v=1622698875",
      },
      {
        volume: 87,
        link: "https://www.mediafire.com/file/rb9labsedg01qor/Piano_Volume_87_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: "87 (Training)",
        link: "https://www.mediafire.com/file/ry3lvbmkjv1juhu/Piano_Volume_87_Training_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: 86,
        link: "https://www.mediafire.com/file/nrb23i6if860tw2/file",
      },
      {
        volume: "86 (Training)",
        link: "https://www.mediafire.com/file/jrtrq7xx8eznkev/file",
      },
      {
        volume: 85,
        link: "https://www.mediafire.com/file/81eh43bxp5fcdx9/Flute%2526Pianov1.5Volume_85_Additional_List_-_pages_1-3_only_%25282%2529.pdf/file",
      },
      {
        volume: 84,
        link: "https://www.mediafire.com/file/hc7arquu5n5knwh/Flute%2526Pianov1.5_Volume_84_Additional_List_-_pages_1-6_only_%25281%2529.pdf/file",
      },
      {
        volume: 83,
        link: "https://www.mediafire.com/file/27vmnj30roblyq7/Flute%2526Pianov1.5-_Volume_83_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 82,
        link: "https://www.mediafire.com/file/gco3b1e73qfb2su/Flute%2526Pianov1.5-_Volume_82_Additional_List_-_pages_1-6_only.pdf/file",
      },
      {
        volume: 81,
        link: "https://www.mediafire.com/file/vfqubjd88fkvvh7/Piano-Flute_-_Volume_81_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 80,
        link: "https://www.mediafire.com/file/ne05vj4a1cacar1/Piano-Flute_-_Volume_80_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 79,
        link: "https://www.mediafire.com/file/z8zja7gu6719ej6/Piano-Flute_Vol_79_Additional_song_list.pdf/file",
      },
    ],
  },
  {
    product: "KS-100 MINIBOX / KS-10 MINI SD",
    volumes: [
      {
        volume: 35,
        link: "https://www.mediafire.com/file_premium/6emegw1mv7un63o/KS-100_Minibox_and_KS-10_Mini_SD_Vol_35_Additional_List__yellow__pp__260923_103502.pdf/file",
      },
      {
        volume: 34,
        link: "https://www.mediafire.com/file_premium/cr577e8o81lx1gv/KS-100_Minibox_and_KS-10_Mini_SD_Vol_34_Additional_List_%2528yellow%2529_pp_1-3_only.pdf/file",
      },
      {
        volume: 33,
        link: "https://www.mediafire.com/file_premium/4o019x0gi90hnts/KS-100_Minibox_and_KS-10_Mini_SD_Vol_33_Additional_List_pp_1-2_only.pdf/file",
      },
      {
        volume: 32,
        link: "https://www.mediafire.com/file_premium/kknvmeutv10pfjx/KS-100_Minibox_and_KS-10_Mini_SD_Vol_32_Additional_List_pp_1-4_only.pdf/file",
      },
      {
        volume: 31,
        link: "https://www.mediafire.com/file_premium/hcw4s6vpjc7vl51/KS-100_Minibox_and_KS-10_Mini_SD_Vol_31_Additional_List_pp_1-2_only.pdf/file",
      },
      {
        volume: 30,
        link: "https://www.mediafire.com/file_premium/xhr43dzu8yx0mfi/KS-100_Minibox_and_KS-10_Mini_SD_Vol_30_Additional_List_pp_1-2_only.pdf/file",
      },
      {
        volume: 29,
        link: "https://www.mediafire.com/file_premium/jpu8u4b4tbtl34m/KS-100_Minibox_and_KS-10_Mini_SD_Vol_29_Additional_List_pp_1-2_only.pdf/file",
      },
      {
        volume: 28,
        link: "https://www.mediafire.com/file_premium/rry8knlf1aaopho/KS-100_Minibox_and_KS-10_Mini_SD_Vol_28_Additional_List_pp_1-2_only.pdf/file",
      },
      {
        volume: 27,
        link: "https://www.mediafire.com/file_premium/fmu2caw69k2thb8/KS-100_Minibox_and_KS-10_Mini_SD_Vol_27_Additional_List_pp_2.pdf/file",
      },
      {
        volume: 26,
        link: "https://www.mediafire.com/file_premium/yoomb45ywme89lk/KS-100_Minibox_and_KS-10_Mini_SD_Vol_26_Additional_List_pp_1-2_only.pdf/file",
      },
      {
        volume: 25,
        link: "https://www.mediafire.com/file_premium/kc0k1tjutr26w74/KS-100_Minibox_and_KS-10_Mini_SD_Vol_25_Additional_List_pp_1-2_only.pdf/file",
      },
      {
        volume: 24,
        link: "https://www.mediafire.com/file_premium/v7sf4l893na8t2e/KS-100_Minibox_and_KS-10_Mini_SD_Vol_24_Additional_List_pp_1-3_only.pdf/file",
      },
      {
        volume: 23,
        link: "https://www.mediafire.com/file_premium/y9peqxzu1fmoeiu/KS-100_Minibox_and_KS-10_Mini_SD_Vol_23_Additional_List_pp_1-3_only.pdf/file",
      },
      {
        volume: 22,
        link: "https://www.mediafire.com/file_premium/otmqb8dosfuk23n/KS-100_Minibox_and_KS-10_Mini_SD_Vol_22_Additional_List_pp_1-4_only.pdf/file",
      },
      {
        volume: 21,
        link: "https://www.mediafire.com/file/jaai6xgcppa3vap/KS-40_-_Volume_21_Additional_pp_1-4_only.pdf/file",
      },
      {
        volume: 20,
        link: "https://www.mediafire.com/file/yoz35go3bdxaeus/KS-40_-_Volume_20_Additional_pp_1-4_only.pdf/file",
      },
      {
        volume: 19,
        link: "https://www.mediafire.com/file/oq50bqxqqqu1trv/KS-5,+KS-10,+KS-100,+KS-10+Mini+Vol+19+Additional+List+pp+1-7+only.pdf/file",
      },
      {
        volume: 18,
        link: "https://www.mediafire.com/file/e6avj1bsrsqtyww/KS-100_Minibox_and_KS-10_Mini_SD_Vol_18_Additional_List_pp_1-9_only.pdf/file",
      },
    ],
  },
  {
    product: "REYNA SERIES",
    volumes: [
      {
        volume: 108,
        link: "https://www.mediafire.com/file_premium/xqdkzqfvo4rdzy3/Reyna_Volume_108_Additional_List__yellow__-_p_260923_103524.pdf/file",
      },
      {
        volume: 106,
        link: "https://www.mediafire.com/file_premium/nq12po54bum3arg/Reyna_Volume_106_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: "104~105",
        link: "https://www.mediafire.com/file_premium/kttezjtjoz4dnw3/Reyna_Volume_104%257E105_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 103,
        link: "https://www.mediafire.com/file_premium/3ttwarokoectrct/Reyna_Volume_103_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: 102,
        link: "https://www.mediafire.com/file_premium/yr8iydhscxlkyvz/Reyna_Volume_102_Additional_List_-_page_1-2_only.pdf/file",
      },
      {
        volume: 101,
        link: "https://www.mediafire.com/file_premium/kckk76jlbl0225l/Reyna_Volume_101_Additional_List_-_page_1_only.pdf/file",
      },
      {
        volume: 100,
        link: "https://www.mediafire.com/file_premium/3axkqopav0wutg5/Reyna_Volume_100_Additional_List_-_pages_2.pdf/file",
      },
      {
        volume: 99,
        link: "https://www.mediafire.com/file_premium/yrcfmpa8bnfnt32/Reyna_Volume_99_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: 98,
        link: "https://www.mediafire.com/file_premium/4miy8rbe2ypyxh5/Reyna_Volume_98_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 96,
        link: "https://www.mediafire.com/file_premium/28gxz9cg75eilr5/Reyna_Volume_96_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 95,
        link: "https://www.mediafire.com/file_premium/j1dh04vacosag0w/T-X%252C_Reyna%252C_Flute%252C_PK-10%252C_Piano%252BSeries_Volume_95_Additional_List-pages_1-3_only.pdf/file",
      },
      {
        volume: 94,
        link: "https://www.mediafire.com/file_premium/1ujaga9j6johquo/T-X_Series_Volume_94_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 93,
        link: "https://www.mediafire.com/file/09kz827b2012rgp/T-X_Series_Volume_93_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 92,
        link: "https://www.mediafire.com/file/1vdczjv4d1jvk2a/T-X_Series_Volume_92_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 91,
        link: "https://www.mediafire.com/file/5g0ijysahpu1l9h/T-X,+Reyna,+Flute,+PK-10,+Piano+Series+Volume+91+Additional+List+-+pages+1-5+only.pdf/file",
      },
      {
        volume: 90,
        link: "https://www.mediafire.com/file/onz1bp4g2o9zsjp/Reyna+Series+Volume+90+Additional+List+-+pages+1-3+only.pdf/file",
      },
      {
        volume: 89,
        link: "https://www.mediafire.com/file/rt5wavrurgin7fe/Reyna_Volume_89_Additional_List_-_pages_1-3_only_-.pdf/file",
      },
      {
        volume: 88,
        link: "https://www.mediafire.com/file/mwugu3mux86pzfo/Reyna_Volume_88_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 87,
        link: "https://www.mediafire.com/file/6h5y1r8ad24k4i3/Reyna_Volume_87_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 86,
        link: "https://www.mediafire.com/file/nfmrles7ja6mzhd/file",
      },
      {
        volume: 85,
        link: "https://www.mediafire.com/file/2q5kux4ljfshe1c/T-X_Series_Volume_85_Additional_List_-_pages_1-3_only_%25282%2529.pdf/file",
      },
      {
        volume: 84,
        link: "https://www.mediafire.com/file/z6u470a0kotteh3/T-X_Series_Volume_84_Additional_List_-_pages_1-6_only_%25281%2529.pdf/file",
      },
      {
        volume: 83,
        link: "https://www.mediafire.com/file/6p2rva1w666w9o0/T_-_X_-_Volume_83_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 82,
        link: "https://www.mediafire.com/file/v2r78wv5ojd3cdt/T_-_X_-_Volume_82_Additional_List_-_pages_1-6_only.pdf/file",
      },
      {
        volume: 81,
        link: "https://www.mediafire.com/file/nbxj5mddjg8gk8l/Reyna_-_Volume_81_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 80,
        link: "https://www.mediafire.com/file/7e84w6rtstbcjmq/Reyna_-_Volume_80_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 79,
        link: "https://www.mediafire.com/file/d9ax2vyvjbm8em2/Reyna_-_Volume_79_Additional_List.pdf/file",
      },
      {
        volume: 78,
        link: "https://www.mediafire.com/file/1cx4cij58s5jkc0/T_-_X_-_Volume_78_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 77,
        link: "https://www.mediafire.com/file/q5gcvcd870duqwp/Reyna_Volume_77_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 76,
        link: "https://www.mediafire.com/file/680b39pw37y970w/Reyna_-_Volume_76_Additional_List.pdf/file",
      },
      {
        volume: 75,
        link: "https://www.mediafire.com/file/ta2iddk2b2g4fva/Reyna_-_Volume_75_Additional_List.pdf/file",
      },
      {
        volume: 74,
        link: "https://www.mediafire.com/file/9q40qew0f0fdwi8/Reyna_-_Volume_74_Additional_List.pdf/file",
      },
      {
        volume: 73,
        link: "https://www.mediafire.com/file/2vgasaen0uu6216/Reyna_-_Volume_73_Additional_List.pdf/file",
      },
      {
        volume: 72,
        link: "https://www.mediafire.com/file/b4iyk94bmd121sl/Reyna_-_Volume_72_Additional_List.pdf/file",
      },
      {
        volume: 71,
        link: "https://www.mediafire.com/file/m7h5qgxfhbo2ah7/Reyna_Volume_71_Additional_Song_List.pdf/file",
      },
      {
        volume: 70,
        link: "https://www.mediafire.com/file/7k3a3a899qqarq8/Reyna_Volume_70_Additional_Song_List.pdf/file",
      },
      {
        volume: 69,
        link: "https://www.mediafire.com/file/qtqce404ke1cmpq/Reyna_Volume_69_Additional_List.pdf/file",
      },
      {
        volume: 68,
        link: "https://www.mediafire.com/file/gtu7tu6ix2ot5o6/Reyna_Volume_68_Additional_List.pdf/file",
      },
      {
        volume: 67,
        link: "https://www.mediafire.com/file/ozck2a5gj1ozfmy/Reyna_Volume_67_Additional_List.pdf/file",
      },
      {
        volume: 66,
        link: "https://www.mediafire.com/file/t81v0wsw49s9iwq/Reyna_Volume_66_Additional_List.pdf/file",
      },
      {
        volume: "64-65",
        link: "https://www.mediafire.com/file/9a1r1y1k295ttxy/Volume_64_-_65_Reyna_Additional_List.pdf/file",
      },
      {
        volume: 63,
        link: "https://www.mediafire.com/file/8maonej7m3v27n6/Reyna_Volume_63_Additional_Song_List.pdf/file",
      },
      {
        volume: 62,
        link: "https://www.mediafire.com/file/7lctu8f4akbymxk/Reyna_Volume_62_Additional_List.pdf/file",
      },
    ],
  },
  {
    product: "T-X SERIES",
    volumes: [
      {
        volume: 108,
        link: "https://www.mediafire.com/file_premium/csib00agvrs6vah/T-X_Series_Volume_108_Additional_List__yellow__-_p_260923_103524.pdf/file",
      },
      {
        volume: 106,
        link: "https://www.mediafire.com/file_premium/o3g3w0xgkpooac5/T-X_Series_Volume_106_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: "104~105",
        link: "https://www.mediafire.com/file_premium/h0uj2lanaejp5qe/T-X_Series_Volume_104%257E105_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 103,
        link: "https://www.mediafire.com/file_premium/lvd5br6gykndw6u/T-X_Series_Volume_103_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: 102,
        link: "https://www.mediafire.com/file_premium/ble2cjad5ockpnh/T-X_Series_Volume_102_Additional_List_-_page_1-2_only.pdf/file",
      },
      {
        volume: 101,
        link: "https://www.mediafire.com/file_premium/a1wb7zg6edtxqtl/T-X_Series_Volume_101_Additional_List_-_page_1_only.pdf/file",
      },
      {
        volume: 100,
        link: "https://www.mediafire.com/file_premium/u5atgjlxnz780om/T-X_Series_Volume_100_Additional_List_-_pages_2.pdf/file",
      },
      {
        volume: 99,
        link: "https://www.mediafire.com/file_premium/71s8owdoztpue56/T-X_Series_Volume_99_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: 98,
        link: "https://www.mediafire.com/file_premium/pyhd6ork5nsak80/T-X_Series_Volume_98_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 96,
        link: "https://www.mediafire.com/file_premium/axesro0hotteyyu/T-X_Series_Volume_96_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 95,
        link: "https://www.mediafire.com/file_premium/xu4up205nfa60mu/T-X_Series_Volume_95_Additional_List-pages_1-3_only_-_Copy.pdf/file",
      },
      {
        volume: 94,
        link: "https://www.mediafire.com/file_premium/1ujaga9j6johquo/T-X_Series_Volume_94_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 93,
        link: "https://www.mediafire.com/file/09kz827b2012rgp/T-X_Series_Volume_93_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 92,
        link: "https://www.mediafire.com/file/1vdczjv4d1jvk2a/T-X_Series_Volume_92_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 91,
        link: "https://www.mediafire.com/file/5g0ijysahpu1l9h/T-X,+Reyna,+Flute,+PK-10,+Piano+Series+Volume+91+Additional+List+-+pages+1-5+only.pdf/file",
      },
      {
        volume: 90,
        link: "https://www.mediafire.com/file/610bvyls60m1z9p/T-X_Series_Volume_90_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 89,
        link: "https://www.mediafire.com/file/dtw1jmm58pkjrjk/T-X_Series_Volume_89_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 88,
        link: "https://www.mediafire.com/file/ydfrwhsb2btk9ri/T-X_Series_Volume_88_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 87,
        link: "https://www.mediafire.com/file/9o3v8wgnyn6hfno/T-X_Series_Volume_87_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 86,
        link: "https://www.mediafire.com/file/nfmrles7ja6mzhd/file",
      },
      {
        volume: 85,
        link: "https://www.mediafire.com/file/2q5kux4ljfshe1c/T-X_Series_Volume_85_Additional_List_-_pages_1-3_only_%25282%2529.pdf/file",
      },
      {
        volume: 84,
        link: "https://www.mediafire.com/file/z6u470a0kotteh3/T-X_Series_Volume_84_Additional_List_-_pages_1-6_only_%25281%2529.pdf/file",
      },
      {
        volume: 83,
        link: "https://www.mediafire.com/file/6p2rva1w666w9o0/T_-_X_-_Volume_83_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 82,
        link: "https://www.mediafire.com/file/v2r78wv5ojd3cdt/T_-_X_-_Volume_82_Additional_List_-_pages_1-6_only.pdf/file",
      },
      {
        volume: 81,
        link: "https://www.mediafire.com/file/s0or51t7y5exy51/T_-_X_-_Volume_81_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 80,
        link: "https://www.mediafire.com/file/ms9onfpileiou58/T_-_X_-_Volume_80_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 79,
        link: "https://www.mediafire.com/file/3o0p8985wsg9ci2/T_-_X_-_Volume_79_Additional_List_-_pages_1-6_only.pdf/file",
      },
      {
        volume: 78,
        link: "https://www.mediafire.com/file/bbqlz825i5htx02/T_-_X_-_Volume_78_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 77,
        link: "https://www.mediafire.com/file/ww5pv7j1tre5dks/T_-_X_-_Volume_77_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 76,
        link: "https://www.mediafire.com/file/c58w2mj9dhb97hx/T_-_X_-_Volume_76_Additional_List.pdf/file",
      },
      {
        volume: 75,
        link: "https://www.mediafire.com/file/wd4vbrc2g5baafx/T_-_X_-_Volume_75_Additional_List.pdf/file",
      },
      {
        volume: 74,
        link: "https://www.mediafire.com/file/kcfwyhccc5i7530/Volume_74_T_-_X_Series.pdf/file",
      },
      {
        volume: 73,
        link: "https://www.mediafire.com/file/fund5l7xepyb8fv/Volume_73_T_-_X_Series.pdf/file",
      },
      {
        volume: 72,
        link: "https://www.mediafire.com/file/4dqd2yyxxet32dy/Volume_72_T_-_X_Series.pdf/file",
      },
      {
        volume: 71,
        link: "https://www.mediafire.com/file/gaa6381lf5a2ul1/Volume_71_T_-_X_Series.pdf/file",
      },
      {
        volume: 70,
        link: "https://www.mediafire.com/file/8oxrrio4d5o533l/Volume_70_T_-_X_Series.pdf/file",
      },
      {
        volume: 69,
        link: "https://www.mediafire.com/file/cgmppzqvw92l612/Volume_69_T_-_X_Series.pdf/file",
      },
      {
        volume: 68,
        link: "https://www.mediafire.com/file/vmim9i5x5ruc1yd/T_-_X_-_Volume_68_Additional_List.pdf/file",
      },
      {
        volume: 67,
        link: "https://www.mediafire.com/file/2202ow2ayvr5fde/Volume_67_T_-_X_Series.pdf/file",
      },
      {
        volume: 66,
        link: "https://www.mediafire.com/file/2mkk5b0fhg586a3/Volume_66_T_-_X_Series.pdf/file",
      },
      {
        volume: 65,
        link: "https://www.mediafire.com/file/no9gtkrpbqhljyb/Volume_65__T_-_X_Series.pdf/file",
      },
      {
        volume: 64,
        link: "https://www.mediafire.com/file/peih3l8nizu4ti3/Volume_64_T_-_X_Series.pdf/file",
      },
      {
        volume: 63,
        link: "https://www.mediafire.com/file/i6rrib99gsfifu7/Volume_63_T_-_X_Series.pdf/file",
      },
      {
        volume: 62,
        link: "https://www.mediafire.com/file/xototrkjul6v5px/Volume_62_T_-_X_Series.pdf/file",
      },
      {
        volume: 61,
        link: "https://www.mediafire.com/file/4546b2psb451ehb/Volume_61_T_-_X_Series.pdf/file",
      },
      {
        volume: 60,
        link: "https://www.mediafire.com/file/etqpfw0rccr1op7/Volume_60_T_-_X_Series.pdf/file",
      },
      {
        volume: 58,
        link: "https://www.mediafire.com/file/av62p9dhizw2v40/Volume_58_T_-_X_Series.pdf/file",
      },
    ],
  },
  {
    product: "KS-40 / KBOX-2 / KBOX-3",
    volumes: [
      {
        volume: 35,
        link: "https://www.mediafire.com/file_premium/ggwf8wlic12cvx5/KS-40_-_Volume_35_Additional_List__yellow__pp__260923_103502.pdf/file",
      },
      {
        volume: 33,
        link: "https://www.mediafire.com/file_premium/8qwkyxj1np4zb8r/KS-40_-_Volume_33_Additional_List_pp_1-2_only.pdf/file",
      },
      {
        volume: "31-32",
        link: "https://www.mediafire.com/file_premium/dvedjgv9i8y58kx/KS-40_-_Volume_31-32_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 30,
        link: "https://www.mediafire.com/file_premium/52st2njktx3d1km/KS-40_-_Volume_30_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: 29,
        link: "https://www.mediafire.com/file_premium/auw1qe598thwod6/KS-40_-_Volume_29_Additional_List_-_page_1_only.pdf/file",
      },
      {
        volume: 28,
        link: "https://www.mediafire.com/file_premium/ukckus2vp6uv2lz/KS-40_-_Volume_28_Additional_List_-_page_1_only.pdf/file",
      },
      {
        volume: 27,
        link: "https://www.mediafire.com/file_premium/y4ch9kmworu3hqc/KS-40_-_Volume_27_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: 26,
        link: "https://www.mediafire.com/file_premium/un2474checc3agm/KS-40_-_Volume_26_Additional_List_-_pages_1-2_only.pdf/file",
      },
      {
        volume: 25,
        link: "https://www.mediafire.com/file_premium/ixrkdnhypahqg22/KS-40_-_Volume_25_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 24,
        link: "https://www.mediafire.com/file_premium/50onpp4nc4f9fjs/KS-40_-_Volume_24_Additional_List_-_pages_1-3_only.pdf/file",
      },
      {
        volume: 23,
        link: "https://www.mediafire.com/file_premium/ui4xxlgqirs1b0h/KS-40_-_Volume_23_Additional_pp_1-3_only.pdf/file",
      },
      {
        volume: 22,
        link: "https://www.mediafire.com/file_premium/7ot5wf691fo1z1x/KS-40_-_Volume_22_Additional_pp_1-4_only.pdf/file",
      },
      {
        volume: 21,
        link: "https://www.mediafire.com/file/jaai6xgcppa3vap/KS-40_-_Volume_21_Additional_pp_1-4_only.pdf/file",
      },
      {
        volume: 20,
        link: "https://www.mediafire.com/file/yoz35go3bdxaeus/KS-40_-_Volume_20_Additional_pp_1-4_only.pdf/file",
      },
      {
        volume: 19,
        link: "https://www.mediafire.com/file/g30qwhtde0ah000/KS-40+-+Volume+19+Additional+pp+1-5+only.pdf/file",
      },
      {
        volume: 18,
        link: "https://www.mediafire.com/file/ni1p2q3r0bvjs64/KS-40_-_Volume_18_Additional_pp_1-6_only.pdf/file",
      },
      {
        volume: 17,
        link: "https://www.mediafire.com/file/1m3x8rv4csqf08k/KS-40_-_Volume_17_Additional_pp_1-4_only.pdf/file",
      },
      {
        volume: 16,
        link: "https://www.mediafire.com/file/ebnvpruk2ipdpor/KS-40_-_Volume_16_Additional_pp_1-3_only.pdf/file",
      },
      {
        volume: 15,
        link: "https://www.mediafire.com/file/l5wv7ez9xooye4i/file",
      },
      {
        volume: 14,
        link: "https://www.mediafire.com/file/7fovc471yb8w9co/KS-40_-_Volume_14_Additional_pp_1-8_only_%25281%2529.pdf/file",
      },
      {
        volume: 12,
        link: "https://www.mediafire.com/file/b3859k77v3dgczu/KS-40_-_Volume_12_Additional_pp_1-8_only.pdf/file",
      },
      {
        volume: 11,
        link: "https://www.mediafire.com/file/sd84ciiz5fxw437/KS-40_-_Volume_11_Additional_pp_1-3_only.pdf/file",
      },
      {
        volume: 10,
        link: "https://www.mediafire.com/file/gsg019aofu4otd1/KS-10-__Vol_10_Additional_List_-_6pp.pdf/file",
      },
      {
        volume: 9,
        link: "https://www.mediafire.com/file/eo5eq4hhshtmbi9/KS-10_and_KS-40_Volume_9_Additional_List.pdf/file",
      },
      {
        volume: 8,
        link: "https://www.mediafire.com/file/6rhixtyxijn6cb6/KS-10_-_Volume_8_Additional_List_-_6pp_only.pdf/file",
      },
      {
        volume: 7,
        link: "https://www.mediafire.com/file/10lb3143i6106p6/KS-10_-_Volume_7_Additional_List_-_10pp_only.pdf/file",
      },
      {
        volume: 6,
        link: "https://www.mediafire.com/file/xqbf5w4qnnkq6wj/KS-10_-_Volume_6_Additional_List_-_7pp_only.pdf/file",
      },
      {
        volume: 5,
        link: "https://www.mediafire.com/file/abez12bxqjcl0z1/KS-10_-_Volume_5_Additional_List_-_4pp_only.pdf/file",
      },
      {
        volume: 4,
        link: "https://www.mediafire.com/file/xl3dl2al21tl88v/KS-10_-_Volume_4_Additional_List_-_3pp_only.pdf/file",
      },
      {
        volume: 3,
        link: "https://www.mediafire.com/file/jg1kgxwcttmt6dg/KS-10_-_Volume_3_Additional_List_-_4pp_only.pdf/file",
      },
      {
        volume: 2,
        link: "https://www.mediafire.com/file/pdlzmtuk4ciasmx/KS-10_-_Volume_2_Additional_List_-_4pp_only.pdf/file",
      },
    ],
  },
  {
    product: "KS-5 / JUNIOR LITE / KS-10 / JUNIOR 2",
    volumes: [
      {
        volume: 35,
        link: "https://www.mediafire.com/file_premium/3oy2sn0fy80p8wy/KS-5_and_KS-10_Vol_35_Additional_List__yellow__pp__260923_103502.pdf/file",
      },
      {
        volume: 33,
        link: "https://www.mediafire.com/file_premium/ftukns1s4akz0kt/KS-5_and_KS-10_Vol_33_Additional_List_pp_1-2_only.pdf/file",
      },
      {
        volume: 32,
        link: "https://www.mediafire.com/file_premium/fiqj13gt5nlf57o/KS-5_and_KS-10_Vol_32_Additional_List_pp_1-4_only.pdf/file",
      },
      {
        volume: 30,
        link: "https://www.mediafire.com/file_premium/7fcwsf8a3w5mmoo/KS-5_and_KS-10_Vol_30_Additional_List_pp_1-2_only.pdf/file",
      },
      {
        volume: 29,
        link: "https://www.mediafire.com/file_premium/28vi88b7tqu81ei/KS-5_and_KS-10_Vol_29_Additional_List_pp_1-2_only.pdf/file",
      },
      {
        volume: 28,
        link: "https://www.mediafire.com/file_premium/mwfemc3dgbo0jfx/KS-5_and_KS-10_Vol_28_Additional_List_pp_1-2_only.pdf/file",
      },
      {
        volume: 27,
        link: "https://www.mediafire.com/file_premium/iq3lveswi8x39i3/KS-5_and_KS-10_Vol_27_Additional_List_pp_1-3_only.pdf/file",
      },
      {
        volume: 26,
        link: "https://www.mediafire.com/file_premium/m51pb0vwx8n7156/KS-5_and_KS-10_Vol_26_Additional_List_pp_1-2_only.pdf/file",
      },
      {
        volume: 25,
        link: "https://www.mediafire.com/file_premium/1xtsd13srpzn4j5/KS-5_and_KS-10_Vol_25_Additional_List_pp_1-2_only.pdf/file",
      },
      {
        volume: 24,
        link: "https://www.mediafire.com/file_premium/gqvpnaxb3gspv8m/KS-5_and_KS-10_Vol_24_Additional_List_pp_1-3_only.pdf/file",
      },
      {
        volume: 23,
        link: "https://www.mediafire.com/file_premium/1yz61d6meiqonac/KS-5_and_KS-10_Vol_23_Additional_List_pp_1-3_only.pdf/file",
      },
      {
        volume: 22,
        link: "https://www.mediafire.com/file_premium/4b3yq7qrnalyxiv/KS-5_and_KS-10_Vol_22_Additional_List_pp_1-5_only.pdf/file",
      },
      {
        volume: 21,
        link: "https://www.mediafire.com/file/sxbvsp641ei2kqr/KS-5_and_KS-10_Vol_21_Additional_List_pp_1-6_only.pdf/file",
      },
      {
        volume: 20,
        link: "https://www.mediafire.com/file/ratl0rxyme1laz8/KS-5_and_KS-10_Vol_20_Additional_List_pp_1-6_only.pdf/file",
      },
      {
        volume: 19,
        link: "https://www.mediafire.com/file/oq50bqxqqqu1trv/KS-5,+KS-10,+KS-100,+KS-10+Mini+Vol+19+Additional+List+pp+1-7+only.pdf/file",
      },
      {
        volume: 18,
        link: "https://www.mediafire.com/file/nwhrtp1o6nlldwx/KS-5_and_KS-10_Vol_18_Additional_List_pp_1-9_only.pdf/file",
      },
      {
        volume: 17,
        link: "https://www.mediafire.com/file/f7lv4du50vposjs/KS-5_and_KS-10_Vol_17_Additional_List_pp_1-6_only.pdf/file",
      },
      {
        volume: 16,
        link: "https://www.mediafire.com/file/jshsjr4ew43znp3/KS-5_and_KS-10_Vol_16_Additional_List_pp_1-5_only.pdf/file",
      },
      {
        volume: 15,
        link: "https://www.mediafire.com/file/g3c2a5asvby91gn/file",
      },
      {
        volume: 14,
        link: "https://www.mediafire.com/file/kd9eht3516l5zrs/KS-5_and_KS-10_Vol_14_Additional_List_pp_1-12_only.pdf/file",
      },
      {
        volume: 12,
        link: "https://www.mediafire.com/file/mkofcnnyciekm10/KS-5_and_KS-10_Vol_12_Additional_List_pp_1-11_only.pdf/file",
      },
      {
        volume: 11,
        link: "https://www.mediafire.com/file/qc5udv1c1x3m4ij/KS-5_and_KS-10_Vol_11_Additional_List_pp_1-4_only_%25281%2529.pdf/file",
      },
      {
        volume: 10,
        link: "https://www.mediafire.com/file/ed1t390twvs3g6q/KS-5_Vol_10_Additional_List_-_6pp.pdf/file",
      },
      {
        volume: 9,
        link: "https://www.mediafire.com/file/gjd0izii5ce0eea/KS-5_Vol_9_Additional_List_-_12pp_.pdf/file",
      },
      {
        volume: 8,
        link: "https://www.mediafire.com/file/bhhzq8na3c2szgz/KS-5_Vol_8_Additional_List_-_6pp_%25282%2529.pdf/file",
      },
      {
        volume: "2-7",
        link: "https://www.mediafire.com/file/y7z44dc06iuzcy4/KS-5_Vol_2-7_Additional_List_-_pp_1_-16_only.pdf/file",
      },
    ],
  },
  {
    product: "BMB / X2 / X1 / HDD",
    years: [
      {
        year: 2020,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/0ol0xmvyb15zjrm/BMB_X2__2020_December_Additional_Song_List.pdf/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/ez031cupanbaq3w/BMB_X2_2020_November_Additional_Song_List.pdf/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/eygbjmq47pasgiz/BMB_X2_2020_October_Additional_Song_List.pdf/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/diuge1xmxocaig6/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/srtx7na0gm9boo6/BMB_X2__2020_August_Additional_Song_List.pdf/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/rjwqwzmtsuoe78x/BMB_X2__2020_July_Additional_Song_List.pdf/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/l1c4ptra5cpgvvd/HDD_2020_June_Additional_Song_List.pdf/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/g9xb72f6w9dcqtr/HDD_2020_May_Additional_Song_List.pdf/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/fga9bxcqt5lwpre/BMB_X2__2020_April_Additional_Song_List.pdf/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/b1i5pupfb1vb51k/BMB_X2__2020_March_Additional_Song_List.pdf/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/t0rsoarrf3qc3gv/BMB_X2__2020_February_Additional_Song_List.pdf/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/brptxihtz369ynk/BMB_X2__2020_January_Additional_Song_List.pdf/file",
          },
        ],
      },
      {
        year: 2019,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/gcpl3qsj4i7wamk/HDD_2019_December_Additional_Song_List.pdf/file",
          },
          {
            month: "November",
            link: "https://www.mediafire.com/file/yzn2nfpqr9lkzpb/HDD_2019_November_Additional_Song_List.pdf/file",
          },
          {
            month: "October",
            link: "https://www.mediafire.com/file/lh1tlmjpiltdy9v/HDD_2019_October_Additional_Song_List.pdf/file",
          },
          {
            month: "September",
            link: "https://www.mediafire.com/file/u7g89fqxyyt2i5g/HDD_2019_September_Additional_Song_List_%25282%2529.pdf/file",
          },
          {
            month: "August",
            link: "https://www.mediafire.com/file/m4diek6cios42la/HDD_2019_August_Additional_Song_List.pdf/file",
          },
          {
            month: "July",
            link: "https://www.mediafire.com/file/ia5oy76si3itsug/HDD_2019_July_Additional_Song_List.pdf/file",
          },
          {
            month: "June",
            link: "https://www.mediafire.com/file/y63tgqniuqj9f0t/HDD_2019_June_Additional_Song_List.pdf/file",
          },
          {
            month: "May",
            link: "https://www.mediafire.com/file/kyxrnj6c1txapz9/HDD_2019_May_Additional_Song_List_Alpha_Major_Cello_X3.pdf/file",
          },
          {
            month: "April",
            link: "https://www.mediafire.com/file/4akdr4aqv4zh4mu/HDD_2019_April_Additional_Song_List.pdf/file",
          },
          {
            month: "March",
            link: "https://www.mediafire.com/file/3wttpfmnnydhtn5/HDD_2019_March_Additional_Song_List.pdf/file",
          },
          {
            month: "February",
            link: "https://www.mediafire.com/file/zbfkcxo0mmwhwjj/HDD_2019_February_Additional_Song_List.pdf/file",
          },
          {
            month: "January",
            link: "https://www.mediafire.com/file/hs4jnkbj54hd0n7/HDD_2019_January_Additional_Song_List.pdf/file",
          },
        ],
      },
      {
        year: 2018,
        months: [
          {
            month: "December",
            link: "https://www.mediafire.com/file/3bvmn612qq1pmx2/BMB_X2_2018_December_Additional_Song_List.pdf/file",
          },
        ],
      },
    ],
  },
  {
    product: "HERMOSA / N20 NANO PLUS",
    volumes: [
      {
        volume: "7-9",
        link: "https://www.mediafire.com/file/azdldt4m5gfgkel/Hermosa_Volume_7-9_Additional_List.pdf/file",
      },
      {
        volume: 6,
        link: "https://www.mediafire.com/file/hi47o8wio19am9v/Home_40%252B_Hermosa_-_Volume_6_Additional_List_6pp_only.pdf/file",
      },
      {
        volume: 5,
        link: "https://www.mediafire.com/file/9wk7hqvidfqdrif/Home_40%252B_Hermosa_-_Volume_5_Additional_List__pp_1-14_only.pdf/file",
      },
      {
        volume: 4,
        link: "https://www.mediafire.com/file/1wkw4u1hbfjwzu2/Home_40%252B_Hermosa_-_Volume_4_Additional_List__pp_1-8_only.pdf/file",
      },
      {
        volume: 3,
        link: "https://www.mediafire.com/file/aabd7x6quvlx73e/Home_40%252B_-_Volume_3_Additional_List_-_4pp_only.pdf/file",
      },
      {
        volume: 2,
        link: "https://www.mediafire.com/file/534y9fryaxokdc9/Home_40%252B_-_Volume_2_Additional_List_-_4pp_only.pdf/file",
      },
    ],
  },
  {
    product: "HOME 40 / NANO OLD",
    volumes: [
      {
        volume: 77,
        link: "https://www.mediafire.com/file/bhaezaux9cod8ab/Home40_Nano_Volume_77_Additional_List_pp_1-17_only.pdf/file",
      },
      {
        volume: "72-76",
        link: "https://www.mediafire.com/file/irw075s1jxkydpe/Home-40_-_Volume_72-76_Additional_List.pdf/file",
      },
      {
        volume: 71,
        link: "https://www.mediafire.com/file/jz5kmfk4ag41183/Home_-_40_Volume_71.pdf/file",
      },
      {
        volume: 67,
        link: "https://www.mediafire.com/file/86s8j1f73tm56p6/Home-40_-_Volume_67_Additional_List_-_6pp_only.pdf/file",
      },
      {
        volume: 64,
        link: "https://www.mediafire.com/file/1mz7v6abm7gas7p/Home-40_Volume_64_SMALL.pdf/file",
      },
      {
        volume: 63,
        link: "https://www.mediafire.com/file/84la69t8nfiee2q/Home_-_40_Volume_63.pdf/file",
      },
      {
        volume: 61,
        link: "https://www.mediafire.com/file/wa1dqn093yjdnod/Home_-_40_Volume_61.pdf/file",
      },
    ],
  },
  {
    product: "BRAVO",
    volumes: [
      {
        volume: 9,
        link: "https://www.mediafire.com/file/yre96hdk77esmw9/Platinum_Bravo__-_Volume_9_Additonal_OPM_only_-_12pp_only.pdf/file",
      },
      {
        volume: 8,
        link: "https://www.mediafire.com/file/9pcb6892l9zmhc2/Volume_8_Platinum_Bravo.pdf/file",
      },
      {
        volume: 7,
        link: "https://www.mediafire.com/file/jvozsaoe8gtevzc/Volume_7_Platinum_Bravo.pdf/file",
      },
      {
        volume: 6,
        link: "https://www.mediafire.com/file/y9svba6gypbrko7/Platinum_Bravo__-_Volume_6_Additonal_2pp_only.pdf/file",
      },
      {
        volume: 5,
        link: "https://www.mediafire.com/file/9jn8kdi2r555br9/Platinum_Bravo__-_June-July_2014_Song_Update_Volume_5.pdf/file",
      },
      {
        volume: 4,
        link: "https://www.mediafire.com/file/kjp3norlvkg7dsa/Platinum_Bravo__-_Feb_2014_Song_Update_Volume_4.pdf/file",
      },
    ],
  },
  {
    product: "P-SERIES",
    volumes: [
      {
        volume: 78,
        link: "https://www.mediafire.com/file/fyo0v2repfn0huw/P-Series_Volume_78_Additional_List.pdf/file",
      },
      {
        volume: 77,
        link: "https://www.mediafire.com/file/oykunkr2ep72ktu/P-Series_Volume_77_Additional_List_-_pages_1-4_only.pdf/file",
      },
      {
        volume: 73,
        link: "https://www.mediafire.com/file/2lllhcub1ac61xu/P-Series_Volume_73_Additional_List.pdf/file",
      },
      {
        volume: 69,
        link: "https://www.mediafire.com/file/860pxyurp7p6lsc/P-Series_Volume_69_Additional_List.pdf/file",
      },
      {
        volume: 67,
        link: "https://www.mediafire.com/file/3xbajpi3lrgv5em/P-Series_Volume_67_Additional_List.pdf/file",
      },
      {
        volume: 64,
        link: "https://www.mediafire.com/file/5dudi4ym7qhc3xw/P-Series_Volume_64_Additional_List.pdf/file",
      },
      {
        volume: 61,
        link: "https://www.mediafire.com/file/o790rq2oogrwlrm/P-Series_Volume_61_Additional_List.pdf/file",
      },
      {
        volume: "53-59",
        link: "https://www.mediafire.com/file/cvbu3krwbbvvq76/P-series_Volume_53_-_59_additional_list.pdf/file",
      },
      {
        volume: "53-56",
        link: "https://www.mediafire.com/file/8tzxa9sl061kfk0/P-Series_Volume_53-56_Additional_List.pdf/file",
      },
    ],
  },
];

const songListHtml = `
<H2 class="songlist">Songlist Update</H2>
   ${songList
     .map(
       ({ product, years, volumes }) => `
      <details class="products">
      <summary class="product">${product}</summary>

        ${
          years
            ? years
                .map(
                  ({ year, months }) => `
            <details class="years">
                <summary class="year">${year}</summary>

                ${months
                  .map(
                    ({ month, link }) => `
                    <div class="month">
                    <p>${month}</p>
                    <a href="${link}" target="_blank">
                    <img src="https://cdn.shopify.com/s/files/1/2581/7224/files/image_preview_1.png?v=1522229496" width="33" height="28"/>
                    </a>
                    </div>
                    `,
                  )
                  .join("")}

                </details>
                `,
                )
                .join("")
            : ""
        }

        ${
          volumes
            ? volumes
                .map(
                  ({ volume, link }) => `
                    <div class="volume">
                    <p>Volume ${volume}</p>
                    <a href="${link}" target="_blank">
                    <img src="https://cdn.shopify.com/s/files/1/2581/7224/files/image_preview_1.png?v=1522229496" width="33" height="28"/>
                    </a>
                    </div>
                    `,
                )
                .join("")
            : ""
        }

            </details>
            `,
     )
     .join("")}
`;

function initSonglistUpdate() {
  //  console.log("INIT SONGLIST RUNNING");

  const root = document.getElementById("songlist-update-root");

  if (!root) return;
  root.innerHTML = songListHtml;
  // root.innerHTML = `
  //   <h1>DEBUG</h1>
  //   <pre>${JSON.stringify(songList, null, 2)}</pre>
  // `;
  const products = document.querySelectorAll(".products");
  products.forEach((product) => {
    product.addEventListener("toggle", () => {
      if (product.hasAttribute("open")) {
        products.forEach((p) => {
          if (p !== product) {
            p.removeAttribute("open");
          }
        });
      }
    });
  });

  const years = document.querySelectorAll(".years");
  years.forEach((year) => {
    year.addEventListener("toggle", () => {
      if (year.open) {
        years.forEach((y) => {
          if (y !== year) {
            y.removeAttribute("open");
          }
        });
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", initSonglistUpdate);
document.addEventListener("shopify:section:load", initSonglistUpdate);
